/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 24 2023
 **/

import { useInfiniteQuery, UseInfiniteQueryOptions, UseInfiniteQueryResult } from "@tanstack/react-query";
import { useSpace } from "@/frameworks/core/API";

export default function useSpaceSearch(
	searchValue: string,
	options?: Omit<
		UseInfiniteQueryOptions<unknown, unknown, InfiniteQueryResult<WebServices.Space.Search.Data>>,
		"queryFn" | "refetchOnWindowFocus"
	>
) {
	const spaceAPI = useSpace();

	return useInfiniteQuery({
		queryKey: ["useSpaceSearch", searchValue],
		queryFn: async ({ pageParam = 1 }) => {
			const result = (await spaceAPI.search.execute({ page: pageParam, searchText: searchValue, pageSize: 20 }))
				.data;
			return { nextPage: pageParam + 1, ...result };
		},
		refetchOnWindowFocus: false,
		...options
	}) as UseInfiniteQueryResult<InfiniteQueryResult<WebServices.Space.Search.Data>, unknown>;
}
